function timeAgoFromNow(date) {
    return moment(date).fromNow();
}

module.exports = {
    timeAgoFromNow
};